<template>
  <div class="step1" v-if="init">
    <h2 class="access_hidden">유의사항 확인</h2>
    <div class="my_point">
      <h3>내 포인트</h3>
      <dl>
        <dt>{{ pointInfo.pointName }}</dt>
        <dd>
          {{ point }} <span class="unit">{{ pointInfo.pointUnitName }}</span>
        </dd>
      </dl>
    </div>
    <p class="step1_description">
      포인트를 현금 캐시백으로 전환 신청합니다.<br />
      안내사항을 확인하시고, 확인 버튼을 누르시면 다음 단계로 이동합니다.
    </p>
    <Viewer class="info" v-if="krpcExchangeNotice" :initialValue="sanitizekrpcExchangeNotice" />
    <!-- <div class="info" v-html="krpcExchangeNotice"></div> -->
    <div v-if="krpcExchangeNotice" class="bt">
      <v-button @handleClick="handleClick" class="btn01" text="확인" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VButton from '@/components/atoms/VButton';
import mixin from '@/utils/mixin';
import { pointErrorMsg } from '@/utils/errorMsg';
import eventBus from '@/utils/eventBus';
import { Viewer } from '@toast-ui/vue-editor';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';

export default {
  mixins: [mixin],
  components: {
    VButton,
    Viewer,
  },
  data() {
    return {
      init: false,
      krpcExchangeNotice: '',
      apiReturnCode: -1,
    };
  },
  computed: {
    ...mapGetters(['serviceInfo', 'isExchangeIframe']),
    ...mapGetters('point', ['pointInfo']),
    ...mapGetters('exchange', ['exchangeCurrency']),
    sanitizekrpcExchangeNotice() {
      return this.$sanitize(this.krpcExchangeNotice);
    },
    point() {
      if (this.pointInfo.length === 0 || (this.pointInfo.point === null && this.pointInfo.expiryPoint === null)) {
        return '-';
      } else if (this.pointInfo.point === 0) {
        return 0;
      } else {
        return this.addComma(this.pointInfo.point);
      }
    },
  },
  async created() {
    if (this.$route.params.serviceUrl) {
      this.setServiceUrl(this.$route.params.serviceUrl);
    }
    await this.getPointInfo();
    const apiReturn = await this.checkExchange();
    const { code } = apiReturn;

    await this.getExchangeInfo();

    const validCode = [0, 2, 3004, 3005, 3006, 3013, 3015, 3017];
    this.apiReturnCode = code;
    if (!validCode.includes(code)) {
      this.$router.replace({ name: 'ErrorPage', params: { errorCode: code } });
    } else {
      this.init = true;
      const info = await this.getExchangeInfo();
      this.krpcExchangeNotice = info.data?.exchangeNotice;
      eventBus.$emit('scrollUpdate');
    }
  },
  beforeDestroy() {
    eventBus.$emit('scrollTop');
  },
  methods: {
    ...mapActions('point', ['getPointInfo']),
    ...mapActions('exchange', ['setExchangeStep', 'checkExchange', 'getExchangeInfo']),
    ...mapActions('modal', ['openModal']),
    ...mapActions(['setServiceUrl']),
    handleClick() {
      const validCode = [0, 2, 3004];
      if (!validCode.includes(this.apiReturnCode)) {
        if (this.apiReturnCode === 3013) {
          const unit = this.pointInfo.pointUnitName;
          const { exchangeMinAmount } = this.exchangeCurrency;

          this.openModal({
            type: 'alert',
            message: this.$t('global.validation.minWithdrawPoint', {
              minValue: this.addComma(exchangeMinAmount),
              unit,
            }),
          });
        } else {
          this.openModal(pointErrorMsg(this.apiReturnCode));
        }
      } else {
        this.setExchangeStep('step2');
        this.$router.replace({ name: 'Step2' });
      }
    },
  },
};
</script>
